import { CartLinesUpdateEvent } from '@shopify/events';

(function initializeShipAidCart() {
  if (window.__rootAndSpringShipAidCart) {
    window.__rootAndSpringShipAidCart.reconcile();
    return;
  }

  let mode = null;
  let sourceEmbed = null;
  let widget = null;
  let paused = true;
  let timer = null;
  let listeners = null;
  let previousCart = '';
  const observer = new MutationObserver(schedule);

  function acceptConfig(embed, config) {
    if (!config || typeof config.planActive !== 'boolean'
      || !Object.prototype.hasOwnProperty.call(config, 'checkoutPlus')) return;
    if (config.checkoutPlus !== null && (typeof config.checkoutPlus !== 'object'
      || Array.isArray(config.checkoutPlus))) return;
    sourceEmbed = embed;
    mode = config.planActive && config.checkoutPlus?.enabled !== true ? 'legacy' : 'checkout';
  }

  function schedule() {
    if (paused || timer !== null) return;
    // Let the runtime finish its loaded-event setup before retiring an instance.
    timer = setTimeout(() => { timer = null; reconcile(); }, 0);
  }

  function reconcile() {
    if (paused) return;
    if (mode === null) {
      for (const embed of document.querySelectorAll('shipaid-widget-v2')) {
        if (embed._hasFinishedSetup) acceptConfig(embed, embed._store);
        if (mode !== null) break;
      }
    }
    if (mode === null) return;
    if (mode === 'checkout') {
      document.querySelectorAll('shipaid-widget[data-horizon-shipaid]').forEach(element => element.remove());
      return;
    }
    if (!customElements.get('shipaid-widget')) return;

    for (const embed of document.querySelectorAll('shipaid-widget-v2')) {
      // Runtime 0.3.223 otherwise reconnects removed main instances immediately.
      embed._aboutToUnload = true;
      embed.remove();
    }
    if (!widget) {
      widget = document.querySelector('shipaid-widget[data-horizon-shipaid]')
        || document.createElement('shipaid-widget');
      widget.setAttribute('data-horizon-shipaid', '');
      widget.setAttribute('currency', sourceEmbed?.getAttribute('currency') || 'USD');
      widget.setAttribute('lang', sourceEmbed?.getAttribute('lang') || 'en');
      widget.setAttribute('data-selector', 'button[name="checkout"]');
      const title = document.createElement('span');
      title.slot = 'title';
      title.textContent = 'Shipping Protection';
      widget.querySelector('[slot="title"]')?.remove();
      widget.append(title);
      // The legacy payload lacks Add to Cart+ and must not overwrite its config.
      widget.addEventListener('shipaid:widget:loaded', event => event.stopPropagation());
    }
    document.querySelectorAll('shipaid-widget[data-horizon-shipaid]').forEach(element => {
      if (element !== widget) element.remove();
    });
    const checkout = document.querySelector('cart-drawer-component dialog[open] button[name="checkout"]')
      || document.querySelector('main button[name="checkout"]')
      || document.querySelector('cart-drawer-component button[name="checkout"]');
    if (checkout && widget.nextElementSibling !== checkout) checkout.before(widget);
    // Keep empty-cart cleanup active after the final merchandise line disappears.
    if (!checkout && !widget.isConnected) document.body.append(widget);
  }

  function onLoaded(event) {
    if (!(event.target instanceof Element) || !event.target.matches('shipaid-widget-v2')) return;
    acceptConfig(event.target, event.detail);
    schedule();
  }

  function onUnprotectedClick(event) {
    const button = event.target instanceof Element
      ? event.target.closest('[data-horizon-shipaid-choice="unprotected"], .shipaid-atc-original-button')
      : null;
    if (!button) return;
    try { sessionStorage.setItem('shipaid-opt-out-by-customer', 'true'); } catch {}
  }

  function onCartUpdated(event) {
    const cart = event.detail?.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    if (event.detail?.data?.source === 'shipaid-atc-plus' && event.detail.protection === true
      && cart.items.some(item => item?.handle === 'shipaid-protection' && Number(item.quantity) > 0)) {
      // A successful protected product action supersedes an older unchecked choice.
      // Do this before deduplication or Horizon can replace the checkout instances.
      document.querySelectorAll('shipaid-widget-v2').forEach(element => {
        if (typeof element._enterToggleMode === 'function') element._enterToggleMode('checked');
      });
    }
    const signature = JSON.stringify({ items: cart.items.map(item => [item.key, item.quantity, item.final_line_price]), total: cart.total_price });
    if (signature === previousCart) return;
    previousCart = signature;
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: cart.items.map(item => ({ id: item.key, quantity: item.quantity })),
      promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {} }),
    }));
  }

  function pause() {
    paused = true;
    observer.disconnect();
    listeners?.abort();
    listeners = null;
    if (timer !== null) clearTimeout(timer);
    timer = null;
  }

  function resume() {
    if (!document.body) return;
    if (paused) {
      paused = false;
      listeners = new AbortController();
      document.addEventListener('shipaid:widget:loaded', onLoaded, { signal: listeners.signal });
      document.addEventListener('shipaid:cart:updated', onCartUpdated, { signal: listeners.signal });
      document.addEventListener('click', onUnprotectedClick, { capture: true, signal: listeners.signal });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    schedule();
  }

  window.__rootAndSpringShipAidCart = { reconcile: schedule };
  window.addEventListener('pagehide', pause);
  window.addEventListener('pageshow', resume);
  customElements.whenDefined('shipaid-widget').then(schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resume, { once: true });
  } else {
    resume();
  }
})();
